const DB = window.indexedDB || window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB ||
    window.msIndexedDB;


let dbPromise

const initDB = () => {
    if (!DB) {
        console.log('This browser doesnt support indexedDB')
        return;
    }
    else {
        // console.log('indexedDB')

        dbPromise = DB.open("Yonnect", 3, (upgradeDb) => {
            // console.log("TP1")


        })

        dbPromise.onerror = (err) => {
            console.log("an error occurred with IndexedDB")
            console.log(err)
        }

        // with this wwe can make schema or shape for our database
        dbPromise.onupgradeneeded = () => {
            // now our database its not refrence to the indexedDb it self but result of open dbPromise so thats gone be the voices db
            const db = dbPromise.result;
            // console.log("onupgradeneeded")

            if (!db.objectStoreNames.contains('desk')) {
                db.createObjectStore('desk', { keyPath: "_id" })
            }

            if (!db.objectStoreNames.contains('messenger')) {
                db.createObjectStore('messenger', { keyPath: "_id" })
            }

            if (!db.objectStoreNames.contains('drive')) {
                db.createObjectStore('drive', { keyPath: "_id" })
            }

            // const store = db.createObjectStore('desk', { keyPath: "_id" })

            // so our database now doesnt have any information  
            // its similar to table in mysql and mongodb colections
            // store.createIndex('voiceid', ['vv'], { unique: true })

        }

        dbPromise.onsuccess = () => {
            // console.log('database opend successfully')
        }

    }
}


const inserDBtData = (table, data, cb) => {

    const db = dbPromise.result;


    const transaction = db.transaction(table, "readwrite");
    if (transaction) {
        const store = transaction.objectStore(table)
        if (Array.isArray(data)) {
            data.forEach(element => {

                store.put(element)

            });
        } else {
            store.put(data)
        }
    }

    transaction.oncomplete = function (event) {
        console.log(event)
        if (cb) {
            cb();
        }
    }


    // return transaction?.complete;
}


const getDBData = (table, data, options, cb) => {

    const db = dbPromise.result;


    const transaction = db.transaction(table, "readwrite");
    let result = []
    if (transaction) {
        const store = transaction.objectStore(table)
        const cursorRequest = store.openCursor();

        // let index = store.index('_id');
        // let cursorRequest = index.openCursor(null, 'prev');

        //  result = store.get('Antbuildz')

        let i = 0
        cursorRequest.onsuccess = e => {
            const cursor = e.target.result;
            if (cursor) {
                if (!options?.limit || i < options.limit) {
                    let shouldAdd = true
                    if (data) {
                        for (const [key, value] of Object.entries(data)) {
                            let dataValue = value.value
                            let cursorValue = cursor.value[value.key]

                            if (value.icase == false) {
                                dataValue = dataValue?.toLowerCase()
                                cursorValue = cursorValue?.toLowerCase()
                            }

                            if (value.operator == '=' || value.operator == '==') {
                                if (cursorValue != dataValue) {
                                    shouldAdd = false
                                }
                            }

                            if (value.operator == 'contains' || value.operator == 'includes') {
                                if (!cursorValue?.includes(dataValue)) {
                                    shouldAdd = false
                                }
                            }

                        }
                    }


                    if (shouldAdd) {
                        result.push(cursor.value)
                        i++
                    }

                    cursor.continue();

                }

            }
        }
    }

    transaction.oncomplete = function (event) {
        if (cb) {
            cb(result);
        }
    }


}


export { dbPromise, getDBData, initDB, inserDBtData }